import { ServiceHandler } from '../../../utils/api.utils';
import type { UserConnection } from '../types/user-connection.types';

export const getUserConnections = ServiceHandler<
  unknown,
  { connections: UserConnection[] }
>({
  url: '/api/chat-agent/v1/user-connections',
});

/**
 * Starts the OAuth flow for a provider. The response's `authorize_url` is the
 * vendor's real consent screen — navigate the browser to it; don't construct it.
 *
 * `return_path` is the console route to land on when the vendor redirects back.
 * chat-agent signs it into the OAuth state and validates it as a same-origin
 * path; anything it rejects (or an older backend that ignores the field) falls
 * back to Moo Studio's My Apps page.
 */
export const startUserConnectionAuthorize = ServiceHandler<
  { return_path: string },
  { authorize_url: string }
>({
  url: '/api/chat-agent/v1/user-connections/:provider/authorize',
  method: 'POST',
});

export const deleteUserConnection = ServiceHandler<unknown, void>({
  url: '/api/chat-agent/v1/user-connections/:provider',
  method: 'DELETE',
});

/**
 * Mutes/unmutes a connection without revoking the grant, so the user can turn
 * an app off and back on without re-running OAuth.
 *
 * Pending backend support — until `GET /user-connections` returns `enabled`,
 * the UI hides the control rather than calling this. See `ConnectableProvider`.
 */
export const setUserConnectionEnabled = ServiceHandler<
  { enabled: boolean },
  UserConnection
>({
  url: '/api/chat-agent/v1/user-connections/:provider',
  method: 'PATCH',
});
